import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box, Typography, TextField, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, IconButton, Dialog,
  DialogActions, DialogContent, DialogTitle, Snackbar, Alert,
  FormControl, InputLabel, Select, MenuItem, Tabs, Tab
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import api, { API_BASE_URL } from "../../utils/api";

const EmailNotifications = () => {
  const [tab, setTab] = useState(0);

  // General UI states
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  // === MODULE NOTIFICATIONS ===
  const [emailNotifications, setEmailNotifications] = useState([]);
  const [modules, setModules] = useState([]);
  const [formData, setFormData] = useState({ module_id: "", email: "" });
  const [editingId, setEditingId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [neighborhoodOptions, setNeighborhoodOptions] = useState([]);

  // === WORK ORDER NOTIFICATIONS ===
  const [workOrderNotifications, setWorkOrderNotifications] = useState([]);
  const [workOrderTypes, setWorkOrderTypes] = useState([]);
  const [woFormData, setWOFormData] = useState({ workorder_type_id: "", email: "" });
  const [editingWOId, setEditingWOId] = useState(null);
  const [openWODialog, setOpenWODialog] = useState(false);

  // === SPECIAL NOTIFICATIONS ===
const [specialNotifications, setSpecialNotifications] = useState([]);
const [specialFormData, setSpecialFormData] = useState({ property_id: "", workorder_type_id: "", email: "" });
const [editingSpecialId, setEditingSpecialId] = useState(null);
const [openSpecialDialog, setOpenSpecialDialog] = useState(false);


// === NEIGHBORHOOD NOTIFICATIONS ===
const [neighborhoodNotifications, setNeighborhoodNotifications] = useState([]);
const [neighborhoodFormData, setNeighborhoodFormData] = useState({
  neighborhood_code: "",
  workorder_type_id: "",
  workorder_subtype_id: "",
  email: ""
});
const [editingNeighborhoodId, setEditingNeighborhoodId] = useState(null);
const [openNeighborhoodDialog, setOpenNeighborhoodDialog] = useState(false);
const [workOrderSubtypes, setWorkOrderSubtypes] = useState([]);


  useEffect(() => {
    fetchModules();
    fetchWorkOrderTypes();
    fetchWorkOrderSubtypes();
    fetchEmailNotifications();
    fetchWorkOrderNotifications();
    fetchSpecialNotifications();
    fetchNeighborhoodNotifications();

  }, []);


  useEffect(() => {
  fetchNeighborhoodList();
}, []);
const fetchNeighborhoodList = async () => {
  try {
    const res = await api.get(`/membersfilter?search=`);

    const rawMembers = Array.isArray(res.data?.members)
      ? res.data.members
      : [];

    const map = new Map(); 
    // { cleanedCode: { label, codes: Set([...]) } }

    for (const m of rawMembers) {
      const raw = m.ClubMembershipTypeCode;
      if (!raw || isRenter(raw)) continue;

      const label = groupNameFor(raw);      // "Southmont Cove"
      const cleaned = groupIdFor(raw);      // "SOUTHMONT COVE"
      const originalCode = canon(raw);      // keep exact membership code like "SC 5A"

      if (!map.has(cleaned)) {
        map.set(cleaned, {
          cleanedCode: cleaned,
          label,
          codes: new Set()
        });
      }

      map.get(cleaned).codes.add(originalCode);
    }

    // Convert map → cleaned list
    const neighborhoods = Array.from(map.values()).map(n => {
      return {
        cleanedCode: n.cleanedCode,
        label: n.label,
        codes: Array.from(n.codes).sort(codeSort)
      };
    });

    // Sort neighborhoods alphabetically
    neighborhoods.sort((a, b) => a.label.localeCompare(b.label));

    setNeighborhoodOptions(neighborhoods);
  } catch (err) {
    console.error("Neighborhood list load error:", err);
    setNeighborhoodOptions([]);
  }
};








  // -------------------------
// Neighborhood Normalizers
// -------------------------
const GROUP_NAME_BY_CODE = {
  "EH CH HILL": "Estate Homes",
  "EH EDGMT": "Estate Homes",
  SV: "Sommerset Villas",
  SC: "Southmont Cove",
  SW: "Sutton Walk",
  WF: "Waterford",
  WW: "Wedgewood",
};

const norm = (v) => (v ?? "").toString().trim();
const canon = (v) => norm(v).replace(/\s+/g, " ").toUpperCase();
const isRenter = (v) => /\bRENTER\b/i.test(v);

const normalizeMembershipCode = (v) => {
  const c = canon(v);
  if (/^(SV|SC|SW|WF|WW)\b/.test(c)) {
    return c.match(/^(SV|SC|SW|WF|WW)/)[1];
  }
  return c;
};

const groupNameFor = (raw) => {
  const c = normalizeMembershipCode(raw);
  return GROUP_NAME_BY_CODE[c] || norm(raw);
};

const groupIdFor = (raw) => canon(groupNameFor(raw));


const codeSort = (a, b) =>
  a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });

  const fetchNeighborhoodNotifications = async () => {
  const res = await api.get(`/neighborhoodNotifications`);
  setNeighborhoodNotifications(res.data);
};


  // === API CALLS ===
  const fetchEmailNotifications = async () => {
    const res = await api.get(`/emailNotification`);
    setEmailNotifications(res.data);
  };

  const fetchWorkOrderNotifications = async () => {
    const res = await api.get(`/workorderTypeNotification`);
    console.log("🧾 workOrderNotifications response:", res.data); // ← ADD THIS
    setWorkOrderNotifications(res.data);
  };
  

  const fetchSpecialNotifications = async () => {
    const res = await api.get(`/specialNotifications`);
    setSpecialNotifications(res.data);
  };

  
  const fetchModules = async () => {
    const res = await api.get(`/modules`);
    setModules(res.data);
  };

  const fetchWorkOrderTypes = async () => {
    const res = await api.get(`/workorder-types`);
    
    setWorkOrderTypes(res.data);
  };

  const fetchWorkOrderSubtypes = async () => {
  const res = await api.get(`/workorder-subtypes`);
  setWorkOrderSubtypes(res.data);
};


  const getWorkOrderTypeName = (id) => {
    const match = workOrderTypes.find((type) => String(type.id) === String(id));
    return match ? match.type : "—";
  };
  
const getSubtypeName = (id) => {
  const match = workOrderSubtypes.find((s) => String(s.id) === String(id));
  return match ? match.subtype_name : "—";
};


  //const getTypeName = (id) => {
    //const type = workOrderTypes.find((t) => String(t.id) === String(id));
   // return type ? type.type : "—";
  //};


  const handleOpenNeighborhoodDialog = (notification = null) => {
  if (notification) {
   setNeighborhoodFormData({
  neighborhood_code: notification.neighborhood_code,
  workorder_type_id: notification.workorder_type_id,
  workorder_subtype_id: notification.workorder_subtype_id || "",
  email: notification.email
});

    setEditingNeighborhoodId(notification.id);
  } else {
    setNeighborhoodFormData({
      neighborhood_code: "",
      workorder_type_id: "",
      workorder_subtype_id: "",
      email: ""
    });
    setEditingNeighborhoodId(null);
  }

  setOpenNeighborhoodDialog(true);
};

const handleCloseNeighborhoodDialog = () => {
  setOpenNeighborhoodDialog(false);
  setEditingNeighborhoodId(null);
};

const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);


const handleNeighborhoodSubmit = async () => {
  try {
    if (editingNeighborhoodId) {
      await api.put(
        `/neighborhoodNotification/${editingNeighborhoodId}`,
        neighborhoodFormData
      );
      setSnackbar({ open: true, message: "Updated!", severity: "success" });
    } else {
      await api.post(`/neighborhoodNotification`, neighborhoodFormData);
      setSnackbar({ open: true, message: "Added!", severity: "success" });
    }

    fetchNeighborhoodNotifications();
    handleCloseNeighborhoodDialog();
  } catch {
    setSnackbar({ open: true, message: "Failed to save.", severity: "error" });
  }
};

const handleDeleteNeighborhood = async (id) => {
  if (!window.confirm("Delete this notification?")) return;
  await api.delete(`/neighborhoodNotification/${id}`);
  fetchNeighborhoodNotifications();
};

  
  // === HANDLERS (MODULE) ===
  const handleFormSubmit = async () => {
    try {
      if (editingId) {
        await api.put(`/emailNotification/${editingId}`, formData);
        setSnackbar({ open: true, message: "Updated!", severity: "success" });
      } else {
        await api.post(`/emailNotification`, formData);
        setSnackbar({ open: true, message: "Added!", severity: "success" });
      }
      fetchEmailNotifications();
      handleCloseDialog();
    } catch {
      setSnackbar({ open: true, message: "Failed to save.", severity: "error" });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this notification?")) return;
    await api.delete(`/emailNotification/${id}`);
    fetchEmailNotifications();
  };

  const handleOpenDialog = (notification = null) => {
    if (notification) {
      setFormData({ module_id: notification.module_id, email: notification.email });
      setEditingId(notification.id);
    } else {
      setFormData({ module_id: "", email: "" });
      setEditingId(null);
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditingId(null);
  };

  // === HANDLERS (WORK ORDER TYPE) ===
  const handleWOFormSubmit = async () => {
    try {
      if (editingWOId) {
        await api.put(`/workorderTypeNotification/${editingWOId}`, woFormData);
        setSnackbar({ open: true, message: "Updated!", severity: "success" });
      } else {
        await api.post(`/workorderTypeNotification`, woFormData);
        setSnackbar({ open: true, message: "Added!", severity: "success" });
      }
      fetchWorkOrderNotifications();
      handleCloseWODialog();
    } catch {
      setSnackbar({ open: true, message: "Failed to save.", severity: "error" });
    }
  };

  const handleDeleteWO = async (id) => {
    if (!window.confirm("Delete this notification?")) return;
    await api.delete(`/workorderTypeNotification/${id}`);
    fetchWorkOrderNotifications();
  };

  const handleOpenWODialog = (notification = null) => {
    if (notification) {
      setWOFormData({ workorder_type_id: notification.workorder_type_id, email: notification.email });
      setEditingWOId(notification.id);
    } else {
      setWOFormData({ workorder_type_id: "", email: "" });
      setEditingWOId(null);
    }
    setOpenWODialog(true);
  };

  const handleCloseWODialog = () => {
    setOpenWODialog(false);
    setEditingWOId(null);
  };


  const handleOpenSpecialDialog = (notification = null) => {
    if (notification) {
      setSpecialFormData({
        property_id: notification.property_id,
        workorder_type_id: notification.workorder_type_id,
        email: notification.email,
      });
      setEditingSpecialId(notification.id);
    } else {
      setSpecialFormData({ property_id: "", workorder_type_id: "", email: "" });
      setEditingSpecialId(null);
    }
    setOpenSpecialDialog(true);
  };
  
  const handleCloseSpecialDialog = () => {
    setOpenSpecialDialog(false);
    setEditingSpecialId(null);
  };
  
  const handleSubmitSpecial = async () => {
    try {
      if (editingSpecialId) {
        await api.put(`/specialNotification/${editingSpecialId}`, specialFormData);
        setSnackbar({ open: true, message: "Updated!", severity: "success" });
      } else {
        await api.post(`/specialNotification`, specialFormData);
        setSnackbar({ open: true, message: "Added!", severity: "success" });
      }
      fetchSpecialNotifications();
      handleCloseSpecialDialog();
    } catch {
      setSnackbar({ open: true, message: "Failed to save.", severity: "error" });
    }
  };
  
  const handleDeleteSpecial = async (id) => {
    if (!window.confirm("Delete this notification?")) return;
    await api.delete(`/specialNotification/${id}`);
    fetchSpecialNotifications();
  };
  

  return (
    <Box sx={{ maxWidth: 900, mx: "auto", p: 4 }}>
      <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>📧 Email Notifications</Typography>

      <Tabs value={tab} onChange={(e, newVal) => setTab(newVal)} sx={{ mb: 3 }}>
  <Tab label="Module Notifications" />
  <Tab label="Work Order Type Notifications" />
  <Tab label="Special Notifications" />
  <Tab label="Neighborhood Notifications" />
</Tabs>


      {tab === 0 && (
        <>
          <Button onClick={() => handleOpenDialog()} variant="contained" sx={{ mb: 2 }}>➕ Add Module Notification</Button>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow><TableCell>ID</TableCell><TableCell>Module</TableCell><TableCell>Email</TableCell><TableCell>Actions</TableCell></TableRow>
              </TableHead>
              <TableBody>
                {emailNotifications.map(n => (
                  <TableRow key={n.id}>
                    <TableCell>{n.id}</TableCell>
                    <TableCell>{n.module}</TableCell>
                    <TableCell>{n.email}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleOpenDialog(n)}><Edit /></IconButton>
                      <IconButton onClick={() => handleDelete(n.id)} color="error"><Delete /></IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}

{tab === 1 && (
  <>
    <Button onClick={() => handleOpenWODialog()} variant="contained" sx={{ mb: 2 }}>➕ Add Work Order Notification</Button>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow><TableCell>ID</TableCell><TableCell>Type</TableCell><TableCell>Email</TableCell><TableCell>Actions</TableCell></TableRow>
        </TableHead>
        <TableBody>
          {workOrderNotifications.map(n => (
            <TableRow key={n.id}>
              <TableCell>{n.id}</TableCell>
              <TableCell>{n.workorder_type}</TableCell>
              <TableCell>{n.email}</TableCell>
              <TableCell>
                <IconButton onClick={() => handleOpenWODialog(n)}><Edit /></IconButton>
                <IconButton onClick={() => handleDeleteWO(n.id)} color="error"><Delete /></IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
)}

{tab === 2 && ( // ✅ FIXED: Now outside of tab === 1
  <>
    <Button onClick={() => handleOpenSpecialDialog()} variant="contained" sx={{ mb: 2 }}>➕ Add Special Notification</Button>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
  <TableRow>
    <TableCell>ID</TableCell>
    <TableCell>Member Code</TableCell>
    <TableCell>Type</TableCell>
    <TableCell>Email</TableCell>
    <TableCell>Actions</TableCell>
  </TableRow>
</TableHead>

        <TableBody>
          {specialNotifications.map((n) => (
            <TableRow key={n.id}>
              <TableCell>{n.id}</TableCell>
              <TableCell>{n.property_id}</TableCell>
              <TableCell>{getWorkOrderTypeName(n.workorder_type_id)}</TableCell>
               {/* Optional: replace with name lookup if you want */}
              <TableCell>{n.email}</TableCell>
              <TableCell>
                <IconButton onClick={() => handleOpenSpecialDialog(n)}><Edit /></IconButton>
                <IconButton onClick={() => handleDeleteSpecial(n.id)} color="error"><Delete /></IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
)}

{tab === 3 && (
  <>
    <Button
      onClick={() => handleOpenNeighborhoodDialog()}
      variant="contained"
      sx={{ mb: 2 }}
    >
      ➕ Add Neighborhood Notification
    </Button>

    <TableContainer component={Paper}>
      <Table>
        <TableHead>
  <TableRow>
    <TableCell>ID</TableCell>
    <TableCell>Neighborhood</TableCell>
    <TableCell>Work Order Type</TableCell>
    <TableCell>Subtype</TableCell>
    <TableCell>Email</TableCell>
    <TableCell>Actions</TableCell>
  </TableRow>
</TableHead>

        <TableBody>
          {neighborhoodNotifications.map((n) => (
            <TableRow key={n.id}>
              <TableCell>{n.id}</TableCell>
              <TableCell>{n.neighborhood_code}</TableCell>
              <TableCell>{getWorkOrderTypeName(n.workorder_type_id)}</TableCell>
              <TableCell>{getSubtypeName(n.workorder_subtype_id)}</TableCell>
              <TableCell>{n.email}</TableCell>
              <TableCell>
                <IconButton onClick={() => handleOpenNeighborhoodDialog(n)}>
                  <Edit />
                </IconButton>
                <IconButton
                  onClick={() => handleDeleteNeighborhood(n.id)}
                  color="error"
                >
                  <Delete />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
)}



     {/* Module Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>{editingId ? "Edit Module Notification" : "Add Module Notification"}</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Module</InputLabel>
            <Select name="module_id" value={formData.module_id} onChange={(e) => setFormData({ ...formData, module_id: e.target.value })}>
              {modules.map(mod => <MenuItem key={mod.id} value={mod.id}>{mod.name}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField label="Email" name="email" fullWidth value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleFormSubmit}>{editingId ? "Update" : "Add"}</Button>
        </DialogActions>
      </Dialog>

      {/* Work Order Type Dialog */}
      <Dialog open={openWODialog} onClose={handleCloseWODialog}>
        <DialogTitle>{editingWOId ? "Edit Work Order Notification" : "Add Work Order Notification"}</DialogTitle>
        <DialogContent sx={{ px: 4, py: 4 }}>
        <FormControl fullWidth variant="outlined" sx={{ mb: 4 }}>
        <InputLabel id="workorder-type-label" sx={{ backgroundColor: 'white', px: 0.5 }}>
  Type
</InputLabel>


  <Select
    labelId="workorder-type-label"
    id="workorder-type"
    name="workorder_type_id"
    value={woFormData.workorder_type_id}
    label="Type" // VERY IMPORTANT
    onChange={(e) =>
      setWOFormData({ ...woFormData, workorder_type_id: e.target.value })
    }
  >
    {workOrderTypes.map((type) => (
      <MenuItem key={type.id} value={type.id}>
        {type.type}
      </MenuItem>
    ))}
  </Select>
</FormControl>





          <TextField label="Email" name="email" fullWidth value={woFormData.email} onChange={(e) => setWOFormData({ ...woFormData, email: e.target.value })} />
        </DialogContent>

        
        <DialogActions>
          <Button onClick={handleCloseWODialog}>Cancel</Button>
          <Button onClick={handleWOFormSubmit}>{editingWOId ? "Update" : "Add"}</Button>
        </DialogActions>
      </Dialog>
<Dialog open={openNeighborhoodDialog} onClose={handleCloseNeighborhoodDialog}>
  <DialogTitle>
    {editingNeighborhoodId ? "Edit Neighborhood Notification" : "Add Neighborhood Notification"}
  </DialogTitle>

  <DialogContent sx={{ px: 4, py: 4 }}>
   <FormControl fullWidth sx={{ mb: 2 }}>
  <InputLabel>Neighborhood</InputLabel>
 <Select
  value={neighborhoodFormData.neighborhood_code}
  onChange={(e) => {
    setNeighborhoodFormData({
      ...neighborhoodFormData,
      neighborhood_code: e.target.value   // ← save exact original code
    });
  }}
>
  {neighborhoodOptions.map(n =>
    n.codes.map(code => (
      <MenuItem key={code} value={code}>
        {n.label} — {code}
      </MenuItem>
    ))
  )}
</Select>

</FormControl>



    <FormControl fullWidth sx={{ mb: 2 }}>
      <InputLabel>Work Order Type (Optional)</InputLabel>
      <Select
        value={neighborhoodFormData.workorder_type_id}
        onChange={(e) =>
          setNeighborhoodFormData({
            ...neighborhoodFormData,
            workorder_type_id: e.target.value
          })
        }
      >
        <MenuItem value="">
          <em>All Types</em>
        </MenuItem>
        {workOrderTypes.map((type) => (
          <MenuItem key={type.id} value={type.id}>
            {type.type}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    <FormControl fullWidth sx={{ mb: 2 }}>
  <InputLabel>Work Order Subtype (Optional)</InputLabel>
  <Select
    value={neighborhoodFormData.workorder_subtype_id}
    onChange={(e) =>
      setNeighborhoodFormData({
        ...neighborhoodFormData,
        workorder_subtype_id: e.target.value
      })
    }
  >
    <MenuItem value="">
      <em>All Subtypes</em>
    </MenuItem>

    {workOrderSubtypes
      .filter(sub =>
        !neighborhoodFormData.workorder_type_id ||
        String(sub.type_id) === String(neighborhoodFormData.workorder_type_id)
      )
      .map((sub) => (
        <MenuItem key={sub.id} value={sub.id}>
          {sub.subtype_name}
        </MenuItem>
      ))
    }
  </Select>
</FormControl>
<TextField
  label="Email"
  type="email"
  fullWidth
  required
  value={neighborhoodFormData.email}
  error={
    neighborhoodFormData.email !== "" &&
    !isValidEmail(neighborhoodFormData.email)
  }
  helperText={
    neighborhoodFormData.email !== "" &&
    !isValidEmail(neighborhoodFormData.email)
      ? "Please enter a valid email address"
      : ""
  }
  onChange={(e) =>
    setNeighborhoodFormData({
      ...neighborhoodFormData,
      email: e.target.value,
    })
  }
/>




  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseNeighborhoodDialog}>Cancel</Button>
    <Button onClick={handleNeighborhoodSubmit}>
      {editingNeighborhoodId ? "Update" : "Add"}
    </Button>
  </DialogActions>
</Dialog>

{/* Special Notification Dialog */}
<Dialog open={openSpecialDialog} onClose={handleCloseSpecialDialog}>
  <DialogTitle>{editingSpecialId ? "Edit Special Notification" : "Add Special Notification"}</DialogTitle>
  <DialogContent sx={{ px: 4, py: 4 }}>
  <TextField
  label="Property ID"
  type="text" // ✅ allows leading zeros
  fullWidth
  sx={{ mb: 2 }}
  value={specialFormData.property_id}
  onChange={(e) => setSpecialFormData({ ...specialFormData, property_id: e.target.value })}
  inputProps={{ maxLength: 10 }} // Optional: limit input length
/>

    <FormControl fullWidth sx={{ mb: 2 }}>
      <InputLabel>Work Order Type</InputLabel>
      <Select
        value={specialFormData.workorder_type_id}
        onChange={(e) => setSpecialFormData({ ...specialFormData, workorder_type_id: e.target.value })}
      >
        {workOrderTypes.map((type) => (
          <MenuItem key={type.id} value={type.id}>{type.type}</MenuItem>
        ))}
      </Select>
    </FormControl>
   <TextField
  label="Email"
  type="email"
  fullWidth
  required
  value={specialFormData.email}
  onChange={(e) =>
    setSpecialFormData({
      ...specialFormData,
      email: e.target.value,
    })
  }
/>

  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseSpecialDialog}>Cancel</Button>
    <Button onClick={handleSubmitSpecial}>{editingSpecialId ? "Update" : "Add"}</Button>
  </DialogActions>
</Dialog>


      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default EmailNotifications;
